import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

export type ViewMode = 0 | 1 | 2;

interface ViewOption {
  value: ViewMode;
  label: string;
  icon: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-list-view-switcher',
  templateUrl: './list-view-switcher.component.html',
  styleUrls: ['./list-view-switcher.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzDropDownModule,
    NzIconModule,
    NzToolTipModule
  ]
})
export class ListViewSwitcherComponent {
  @Input() view: ViewMode = 0;
  @Output() readonly viewChange = new EventEmitter<ViewMode>();

  viewOptions: ViewOption[] = [
    {
      value: 0,
      label: 'Table View',
      icon: 'table',
      disabled: false
    },
    {
      value: 1,
      label: 'Card View',
      icon: 'appstore',
      disabled: false
    },
    {
      value: 2,
      label: 'Grid View',
      icon: 'insert-row-above',
      disabled: false
    }
  ];

  get activeOption(): ViewOption {
    return (
      this.viewOptions.find(option => option.value === this.view) ||
      this.viewOptions[0]
    );
  }

  handleViewChange(view: ViewMode): void {
    this.view = view;
    this.viewChange.emit(view);
  }
}
